import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 5 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  class: "is-flex is-justify-content-start",
  style: {"gap":"1em"}
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 3 }

import { useStore } from "vuex";
import { computed, onMounted, ref, Ref } from "vue";


import { defineComponent, defineProps } from 'vue'
import { Notyf } from "notyf";

const notyf = new Notyf()

const __default__ = defineComponent({
  name: "UserTableRow"
})

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: ['userData', 'parentShowCustomerData', 'parentShowVetData'],
  setup(__props) {

const props = __props
const store = useStore()
const editing = ref(false)
const editedName = ref('')
const editedEmail = ref('')
const editedPhone = ref('')
const editedWhatsapp = ref('')
const editedAddress = ref('')
//const editedSpecialty = ref('')
const editedTaxId = ref('')
const imageInput : Ref<HTMLInputElement | null> = ref(null)

const toggleEditing = () => {
  editedName.value = props.userData.name
  editedEmail.value = props.userData.email
  editedPhone.value = props.userData.phone
  editedAddress.value = props.userData.address
  //editedSpecialty.value = props.userData.specialty
  editedTaxId.value = props.userData.tax_id
  editing.value = !editing.value
}

const remove = async (userData: any, $t: any) => {
  if (confirm($t && $t('UserData.ConfirmDelete'))) {
    //TODO:Create notification to ask if it is really to delete
    try {
      await store.dispatch('deleteUser', userData)
      notyf.success($t('UserData.NotyfUserRemoved'))
    } catch (e) {
      notyf.error($t('UserData.NotyfErrorRemoveUser'))
    }
  }
}

const save = async ($t: any) => {


  try {
    await store.dispatch('changeName', {
      name: editedName.value,
      user_id: props.userData.user_id,
    })

    await store.dispatch('changeEmail', {
      email: editedEmail.value,
      user_id: props.userData.user_id,
    })

    /*
    await store.dispatch('changePhone', {
      phone: editedPhone.value,
      user_id: props.userData.user_id,
      type: props.userData.type
    })
    */

    /*
    await store.dispatch('changeSpecialty', {
      specialty: editedSpecialty.value,
      user_id: props.userData.user_id,
    })
    */

    await store.dispatch('fetchUsers', props.userData.type)

    toggleEditing()
    notyf.success($t('UserData.NotyfDataEdited'))
  } catch (e) {
    notyf.error($t('UserData.NotyfErrorUpdatingData'))
  }

}

const userImageURL = computed(() => {
  const random = Math.round(99999 * Math.random())
  return process.env.BASE_URL + `api/users/image/${props.userData.user_id}/?hash=${random}`
})

const selectFile = () => {
  if (imageInput && imageInput.value) {
    imageInput.value.click()
  } else {
    console.error("imageInput is not defined or its value is null.")
  }
  // previous version had a ts error.
  // imageInput.value.click()
}

const uploadImage = async ($t : any) => {
  try
  {
    if (imageInput.value && imageInput.value.files && imageInput.value.files[0])
    {
      await store.dispatch('uploadUserImage', {
        user_id: props.userData.user_id,
        file: imageInput.value.files[0]
      });
  
      store.dispatch('fetchUsers', props.userData.type)
    }
    else
    {
      console.error("No file selected or imageInput is null.");
      notyf.error($t('UserData.NotyfErrorUploadingPhoto'));
    }
  } 
  catch (e)
  {
    notyf.error($t('UserData.NotyfErrorUploadingPhoto'))
  }
}

onMounted(() => {

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("th", null, _toDisplayString(__props.userData.user_id), 1),
    (__props.userData.type != 'customer')
      ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
          _createElementVNode("figure", {
            class: "image is-64x64 pointer",
            onClick: selectFile
          }, [
            _createElementVNode("img", {
              class: "is-rounded",
              src: userImageURL.value,
              alt: "click_to_upload"
            }, null, 8, _hoisted_2)
          ]),
          _createElementVNode("input", {
            type: "file",
            class: "is-hidden",
            ref_key: "imageInput",
            ref: imageInput,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (uploadImage(_ctx.$t)))
          }, null, 544)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("td", null, [
      (!editing.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.userData.name), 1))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editedName).value = $event)),
            class: "input"
          }, null, 512)), [
            [_vModelText, editedName.value]
          ])
    ]),
    _createElementVNode("td", null, [
      (!editing.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.userData.email), 1))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editedEmail).value = $event)),
            class: "input"
          }, null, 512)), [
            [_vModelText, editedEmail.value]
          ])
    ]),
    (__props.userData.type != 'manager')
      ? (_openBlock(), _createElementBlock("td", _hoisted_5, [
          (!editing.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.userData.phone), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editedPhone).value = $event)),
                class: "input"
              }, null, 512)), [
                [_vModelText, editedPhone.value]
              ])
        ]))
      : _createCommentVNode("", true),
    (__props.userData.type == 'customer')
      ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
          (!editing.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(__props.userData.crmv), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editedAddress).value = $event)),
                class: "input"
              }, null, 512)), [
                [_vModelText, editedAddress.value]
              ])
        ]))
      : _createCommentVNode("", true),
    (__props.userData.type == 'customer')
      ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
          (!editing.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(__props.userData.crmv_state), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editedAddress).value = $event)),
                class: "input"
              }, null, 512)), [
                [_vModelText, editedAddress.value]
              ])
        ]))
      : _createCommentVNode("", true),
    (__props.userData.type == 'customer')
      ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
          (!editing.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(__props.userData.address), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "text",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editedAddress).value = $event)),
                class: "input"
              }, null, 512)), [
                [_vModelText, editedAddress.value]
              ])
        ]))
      : _createCommentVNode("", true),
    (__props.userData.type == 'customer')
      ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
          (!editing.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(__props.userData.tax_id), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "text",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editedTaxId).value = $event)),
                class: "input"
              }, null, 512)), [
                [_vModelText, editedTaxId.value]
              ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_15, [
        (__props.userData.type == 'manager')
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (!editing.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "button is-warning is-small",
                    onClick: toggleEditing
                  }, _toDisplayString(_ctx.$t('General.Edit')), 1))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "button is-success is-small",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (save(_ctx.$t)))
                  }, _toDisplayString(_ctx.$t('General.Save')), 1))
            ]))
          : _createCommentVNode("", true),
        (__props.userData.type == 'customer')
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("button", {
                class: "button is-success is-small",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (__props.parentShowCustomerData(__props.userData)))
              }, _toDisplayString(_ctx.$t('General.Details')), 1)
            ]))
          : _createCommentVNode("", true),
        (__props.userData.type == 'vet')
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("button", {
                class: "button is-success is-small",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (__props.parentShowVetData(__props.userData)))
              }, _toDisplayString(_ctx.$t('General.Details')), 1)
            ]))
          : _createCommentVNode("", true),
        (!editing.value && __props.userData.type != 'customer')
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("button", {
                class: "button is-danger is-small",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (remove(__props.userData, _ctx.$t)))
              }, _toDisplayString(_ctx.$t('General.Delete')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})